import MarginGroup from 'app/components/layout/MarginGroup';
import { sectionHeaderStyles } from 'app/components/presentation/text/styles';
import { flexCascade, firefoxPrintHackStyles } from 'app/constants/Styles';
import { useClasses } from 'app/utils/css';
import React, { Fragment, ReactNode } from 'react';

interface ISectionProps {
  children: ReactNode;
  header?: ReactNode;
  headerActionItem?: ReactNode;
  headerPadding?: '0 5px' | '0';
}

const SectionContent = ({ children, header, headerActionItem, headerPadding = '0 5px' }: ISectionProps) => {
  const classes = useClasses({
    container: {
      ...flexCascade,
      boxSizing: 'border-box',
      margin: '0 auto',
      width: '100%',
      '@media print': firefoxPrintHackStyles,
    },

    header: {
      alignItems: 'flex-end',
      display: 'flex',
      justifyContent: 'space-between',
    },

    headerText: sectionHeaderStyles,

    headerActionItem: {
      marginLeft: '10px',
    },
  });

  return (
    <section className={classes.container}>
      <MarginGroup margin="25px">
        {header &&
          <header className={classes.header} style={{ padding: headerPadding }}>
            <h2 className={classes.headerText}>{header}</h2>
            {headerActionItem && <span className={classes.headerActionItem}>{headerActionItem}</span>}
          </header>}

        <Fragment>
          {children}
        </Fragment>
      </MarginGroup>
    </section>
  );
};

export default SectionContent;
